<template>
    <div  class="transition-all test flex flex-col fixed top-0 left-0 w-screen h-screen  items-center justify-center  z-40 bg-[#00000063] backdrop-blur-[2px]  text-lg">
        <div class="max-lg:w-[90%] w-[500px]  2xl:w-[550px] hover:transition-all rounded-lg bg-white z-50  py-5 px-12 max-sm:px-6">
            <div class=" flex flex-col items-center gap-3 py-3">
                <div class="rounded-full p-4 max-w-[100px] max-h-[100px] " :class="{'bg-green-100' : success, 'bg-red-100' : !success}">
                    <div class="rounded-full p-3 flex items-center justify-center " :class="{'bg-[#016B00]' : success, 'bg-[#AB0000]' : !success}">
                        <div class="h-auto" id="pencil" style="width: 120px;">
                            <img v-if="success" src="./PromptSvg/success.svg" class="m-0 p-0 block border-0">
                            <img v-if="!success" src="./PromptSvg/error.svg" class="m-0 p-0 block border-0">
                        </div>
                    </div>
                </div>
                <p class="font-bold text-2xl text-center" :class="{'text-[#016B00]' : success, 'text-[#AB0000]' : !success}">{{ header }}</p>
                <p class="text-gray-600 text-lg mx-7 justify-center text-center ">{{ header1 }}</p>
            </div>
            <div class="h-[80px] flex justify-center items-center gap-5">
                <button :class="{'bg-[#016B00] hover:bg-[#014900]': success ,'bg-[#AB0000] hover:bg-[#5e0000]': !success ,}" class="p-3 rounded-lg font-semibold  uppercase text-xl h-12  cursor-pointer  text-white w-full flex items-center justify-center " @click="$emit('close')">OK</button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue"

export default defineComponent({
    components:{
    },
    props:{
        type:{
            type: String
        },
        remarks:{
            type: Boolean,
            default: false
        },
        success:{
            type: Boolean,
            default: true,
        },
        header:{
            type: String,
            default : 'header'
        },
        header1:{
            type: String,
            default : 'header1'
        },
    
    }
})




</script>